
const Hero = () => {

    return (
    <section className="pt-32 md:pt-32  text-black overflow-hidden relative bg-white ">
      <div className="container md:pb-14 mx-auto px-6 flex flex-col lg:flex-row items-center border-b border-gray-200">
        {/* Text Content */}
        <div className="lg:w-1/2 relative z-10 ">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 leading-tight text-gray-900">
            Financial Advisory for{' '}
            <span className="bg-gradient-to-r from-[#3435cf] to-emerald-500 bg-clip-text text-transparent">
              Startups & Investors
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-900 mb-10 max-w-3xl">
            From seed to strategic exit, we partner with startups, funds, and enterprises to deliver clarity, capital, and long-term value. 


          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="bg-[#3435cf] hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 text-center"
            >
              Get Started
            </a>
            <a
              href="#services"
              className="bg-gray-700 hover:bg-gray-900 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1 text-center border border-white/20"
            >
              Explore Expertise
            </a>
          </div>
        </div>

        {/* Image Section */}
        <div className="lg:w-1/2 mt-10 lg:mt-0 lg:relative z-10">
          <img
            // src="/assets/hero-1.png"
            src={`${process.env.PUBLIC_URL}/assets/hero-1.png`}
            alt="Hero"
            className="w-full h-auto"
          />


        </div>

        {/* Lottie Animation */}
        {/* <div className="lg:w-2/5 mt-0 lg:mt-6 lg:relative z-0 md:block md:absolute md:h-2/3 md:opacity-10 lg:opacity-100 hidden">
          <lottie-player
            src="https://assets1.lottiefiles.com/packages/lf20_sk5h1kfn.json"
            background="transparent"
            speed="1"
            loop
            autoplay
            className=" max-w-xl mx-auto"
          ></lottie-player>
        </div> */}
      </div>
    </section>
  );
};

export default Hero;